import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
    getTopTags,
    getMlTags,
    getTaxonomy,
    getTagsLoading,
    getChallengeTotalMlTags,
    getChallengeTotalDistilledTags,
    getChallenge,
} from '../selectors';
import { getUserPermissionsKeys } from '../../auth/selectors';
import { PropTypes } from 'prop-types';
import { topTagsRequested } from '../actions';
import { DROPDOWNDATA } from './constants';
import TopTagsCard from '../../../common/TopTagsCard';

function TopTags({
    challenge,
    onLoad,
    topTags,
    mlTags,
    totalTags,
    totalMlTags,
    taxonomy,
    tagsLoading,
    permissions,
}) {
    useEffect(() => {
        onLoad(DROPDOWNDATA[0].key);
    }, []);

    useEffect(() => {
        if (challenge) onLoad(DROPDOWNDATA[0].key);
    }, [challenge]);

    return (
        <TopTagsCard
            id={'-challenge-tags'}
            taxonomy={taxonomy}
            onTaxonomySelect={onLoad}
            topTags={topTags}
            tagsLoading={tagsLoading}
            totalTags={totalTags}
            totalMlTags={totalMlTags}
            mlTags={mlTags}
            permissions={permissions}
        />
    );
}

TopTags.propTypes = {
    challenge: PropTypes.object,
    onLoad: PropTypes.func.isRequired,
    topTags: PropTypes.arrayOf(PropTypes.object),
    mlTags: PropTypes.arrayOf(PropTypes.object),
    totalTags: PropTypes.string,
    // total count of Machine generated tags
    totalMlTags: PropTypes.string,
    taxonomy: PropTypes.string,
    tagsLoading: PropTypes.bool,
    // array of strings that contains user permissions
    permissions: PropTypes.arrayOf(PropTypes.string),
};

TopTags.defaultProps = {
    topTags: [],
    mlTags: [],
    totalTags: 0,
    totalMlTags: 0,
    taxonomy: '',
    tagsLoading: false,
    permissions: [],
};

const mapStateToProps = (state) => {
    return {
        challenge: getChallenge(state),
        topTags: getTopTags(state),
        mlTags: getMlTags(state),
        totalTags: getChallengeTotalDistilledTags(state),
        totalMlTags: getChallengeTotalMlTags(state),
        taxonomy: getTaxonomy(state),
        tagsLoading: getTagsLoading(state),
        permissions: getUserPermissionsKeys(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoad: (taxonomy) => dispatch(topTagsRequested(taxonomy)),
    };
};

const ConnectedTopTags = connect(mapStateToProps, mapDispatchToProps)(TopTags);

export default ConnectedTopTags;
